import { render, staticRenderFns } from "./EmployeeViewer.vue?vue&type=template&id=b2efb136&"
import script from "./EmployeeViewer.vue?vue&type=script&lang=js&"
export * from "./EmployeeViewer.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeViewer.vue?vue&type=style&index=0&id=b2efb136&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports